"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResultFilterService = void 0;
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const SearchResultTranslationService_1 = require("./SearchResultTranslationService");
class SearchResultFilterService {
    constructor() {
        this.getTransformToFilterMergedOptions = (mergedOptions = []) => {
            const cacheKey = JSON.stringify(mergedOptions);
            if (this.mergedOptionsTransformCache.has(cacheKey)) {
                return this.mergedOptionsTransformCache.get(cacheKey);
            }
            const mergedOptionsValues = new Set(mergedOptions.map(option => option.targetOption));
            const transformFn = (items) => items.filter(item => !mergedOptionsValues.has(item.value));
            this.mergedOptionsTransformCache.set(cacheKey, transformFn);
            return transformFn;
        };
        this.getRefineWithMergedOptions = (mergedOptions, refine) => (value) => {
            const mergedOption = mergedOptions.find(option => option.option === value);
            if (mergedOption) {
                refine(mergedOption.targetOption);
                refine(value);
            }
            else {
                refine(value);
            }
        };
        this.buildFilterDetailsMap = (selectedTab, filterTypeKey) => {
            var _a;
            return (_a = selectedTab[filterTypeKey]) === null || _a === void 0 ? void 0 : _a.map(attribute => {
                var _a;
                if (attribute.type === app_1.FilterTypeEnum.MultiSelect) {
                    return {
                        attribute,
                        details: (0, react_instantsearch_1.useRefinementList)({
                            attribute: attribute.key,
                            sortBy: ['name:asc'],
                            limit: 1000,
                            transformItems: ((_a = attribute.mergedOptions) === null || _a === void 0 ? void 0 : _a.length)
                                ? this.getTransformToFilterMergedOptions(attribute.mergedOptions)
                                : undefined,
                        }),
                    };
                }
                else {
                    return {
                        attribute,
                        details: (0, react_instantsearch_1.useMenu)({
                            attribute: attribute.key,
                            sortBy: ['name:asc'],
                            limit: 1000,
                        }),
                    };
                }
            });
        };
        this.buildClearRefinementsMap = (selectedTab) => {
            var _a;
            const dependedFiltersMap = this.getDependedFiltersMap(selectedTab.attributes);
            return (_a = selectedTab.attributes) === null || _a === void 0 ? void 0 : _a.map(attribute => {
                const cleanFilterKey = dependedFiltersMap[attribute.key]
                    ? [attribute.key, dependedFiltersMap[attribute.key]]
                    : [attribute.key];
                return (0, react_instantsearch_1.useClearRefinements)({
                    includedAttributes: cleanFilterKey,
                });
            });
        };
        this.buildFilters = (filterDetailsMap, clearRefinementsMap, dictionary) => {
            return filterDetailsMap === null || filterDetailsMap === void 0 ? void 0 : filterDetailsMap.map(({ attribute, details }, index) => {
                var _a, _b;
                return ({
                    key: attribute.key,
                    label: dictionary[attribute.label] || attribute.label,
                    mobileLabel: (_a = (dictionary[attribute.mobileLabel] || attribute.mobileLabel)) !== null && _a !== void 0 ? _a : undefined,
                    items: SearchResultTranslationService_1.searchResultTranslationService.provideStructureAndTranslatedLabel(details.items, dictionary),
                    isHidden: attribute.isHidden,
                    type: attribute.type,
                    guiType: (_b = attribute === null || attribute === void 0 ? void 0 : attribute.guiType) !== null && _b !== void 0 ? _b : app_1.FilterGuiTypeEnum.Radio,
                    refine: attribute.mergedOptions
                        ? this.getRefineWithMergedOptions(attribute.mergedOptions, details.refine)
                        : details.refine,
                    clearRefinements: clearRefinementsMap[index].refine,
                    dependentOn: (attribute === null || attribute === void 0 ? void 0 : attribute.dependentOn) || null,
                    gtmKey: (attribute === null || attribute === void 0 ? void 0 : attribute.gtmKey) || '',
                });
            });
        };
        this.mergedOptionsTransformCache = new Map();
        this.getDependedFiltersMap = (items) => {
            return items.reduce((acc, item) => {
                if (item.dependentOn) {
                    acc[item.dependentOn] = item.key;
                }
                return acc;
            }, {});
        };
    }
    transformHierarchyToFilters(items) {
        const result = [items];
        const collectRefinedChildren = (menuItems) => {
            const refinedItem = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(item => { var _a; return item.isRefined && ((_a = item.data) === null || _a === void 0 ? void 0 : _a.length) > 0; });
            if (refinedItem) {
                result.push(refinedItem.data);
                collectRefinedChildren(refinedItem.data);
            }
        };
        collectRefinedChildren(items);
        return result;
    }
    orderFilterWithStatusAtEnd(filters, hierarchyFilters) {
        const visibleFilters = filters.filter(filter => filter.isHidden !== true);
        if (hierarchyFilters.length === 0) {
            return visibleFilters;
        }
        const statusFilter = visibleFilters.find(filter => filter.key === 'status');
        const filtersWithoutStatus = statusFilter
            ? visibleFilters.filter(filter => filter !== statusFilter)
            : visibleFilters;
        return statusFilter
            ? [...filtersWithoutStatus, ...hierarchyFilters, statusFilter]
            : [...filtersWithoutStatus, ...hierarchyFilters];
    }
    getKeyMappedFilters(filters, hierarchyFilters) {
        return [...filters, ...hierarchyFilters].reduce((acc, filter) => {
            acc[filter.key] = filter;
            return acc;
        }, {});
    }
}
exports.searchResultFilterService = new SearchResultFilterService();
